export { useK8sModels } from '@console/dynamic-plugin-sdk/src/utils/k8s/hooks';
